import React from 'react';
import { FormProvider } from 'react-hook-form';
import { ToastContainer } from 'react-toastify';
import { useWorkshopRegistration } from './hooks/useWorkshopRegistration';
import WorkshopRegistrationHeader from './Components/WorkshopRegistrationHeader';
import WorkshopRegistrationForm from './Components/WorkshopRegistrationForm';
import WorkshopRegistrationSuccess from './Components/WorkshopRegistrationSuccess';

/**
 * WorkshopRegistrationPage
 * Declarative page coordinator for the Saddle Making Workshop (ورشة السرج).
 * Follows EAHS Clean Architecture layer separation.
 */
export default function WorkshopRegistrationPage() {
    const {
        methods,
        handleSubmit,
        onSubmit,
        handleReset,
        isSubmitted,
        submittedName,
        isSubmitting,
    } = useWorkshopRegistration();

    return (
        <FormProvider {...methods}>
            <ToastContainer
                position="top-right"
                theme="colored"
                autoClose={6000}
            />

            <div className="row justify-content-center">
                <div className="col-xl-7 col-lg-8 col-md-10 col-12">
                    <WorkshopRegistrationHeader />

                    {isSubmitted ? (
                        <WorkshopRegistrationSuccess
                            submittedName={submittedName}
                            onReset={handleReset}
                        />
                    ) : (
                        <WorkshopRegistrationForm
                            isSubmitting={isSubmitting}
                            onSubmit={handleSubmit(onSubmit)}
                        />
                    )}
                </div>
            </div>
        </FormProvider>
    );
}
